<template>
  <v-container :class="{'align-center':!printing}">   
    <v-card-title primary-title>
      <div class="text-h4 font-weight-light">
        {{ label }}
      </div>        
      <!-- BUNDLES -->
      <v-container v-if="printing">
        <v-simple-table dense>
          <template v-slot:default>
            <thead align="left">
              <tr>
                <th>
                  Title
                </th>
                <th>
                  Utgåva
                </th>
                <th>
                  Utgivningsdatum
                </th>
                <th>
                  Bunt
                </th>
                <th>
                  Retur
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(paper) in papers"
                :key="paper.id"
              >
                <td>{{ paper.title }}</td>
                <td v-if="paper.type === 1">
                  {{ paper.edition }}
                </td>
                <td v-if="paper.type === 0" />
                <td> {{ paper.deliveryDate|longPaperDate }} </td>
                <td />
                <td />
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-container>
      <v-container v-if="!printing">
        <v-layout wrap>
          <v-col v-for="b in openBundles" :key="b.bundleId" cols="6" sm="4" md="3" lg="2" class="mb-0">
            <v-chip v-if="b.open"
                    outlined     
                    @click="showBundle(b)"                    
            >
              <BundleProgress :bundle="b" :extra="0" size="small" />
            </v-chip>    
          </v-col>
          <v-col v-if="openBundles.length < 1" xs12 class="mb-0">
            <i>- Ingen öppen bunt</i>
          </v-col>
        </v-layout>
      </v-container>   
    </v-card-title>
    <v-container v-if="loading && !printing">
      <v-overlay>
        <v-row class="fill-height"
               align-content="center"
               justify="center"
        >
          <v-col
            class="text-subtitle-1 text-center"
            cols="12"
          >
            Hämtar data...
          </v-col>
          <v-col cols="12">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6"
            />
          </v-col>
        </v-row>        
      </v-overlay>
    </v-container>   
    <v-container v-if="papers.length > 0 && !printing">
      <v-row v-if="$vuetify.breakpoint.mdAndUp" dense class="ma-1 text-h6 font-weight-light text-uppercase"> 
        <v-col cols="2">
          Titel
        </v-col>
        <v-col cols="3">
          Utgåva
        </v-col>
        <v-col cols="2">
          Utgivningsdatum
        </v-col>
        <v-spacer />
        <v-col cols="1" :offset="isReportStateRetur ?'1':''"> 
          Bunt
        </v-col>
        <v-col cols="1">
          Retur
        </v-col>
        <v-col :cols="isReportStateRetur?'2':'3'" />                  
      </v-row>                
      <v-form ref="form" v-model="valid" lazy-validation @submit="validate">
        <template v-for="(paper) in papers">
          <PaperWeb :key="paper.id" :paper="paper" :report-state="reportState" :is-report-state-retur="isReportStateRetur" />        
        </template>
      </v-form>
    </v-container>
    <v-container v-else-if="!printing && papers.length === 0">
      <h3>Inget att rapportera</h3>
    </v-container>
    <ConfirmReportDialog ref="confirmDialog" :paper-type="paperType" />   
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { APP_DATES, APP_OPEN_BUNDLES,APP_PAPERS, APP_LAST_SELECTED_BUNDLE_ID } from '@/store/appStates'
import { SET_PAPERS, SET_OPEN_BUNDLES, REMOVE_LAST_SELECTED_BUNDLE_ID, SET_LAST_SELECTED_BUNDLE_ID } from '@/store/appMutations'
import { types } from '@/model/reportState'
import { clone } from 'lodash'
import BundleProgress from '@/components/web/BundleProgress'
import PaperWeb from '@/components/web/Paper.vue'
import ConfirmReportDialog from '@/components/web/dialogs/ConfirmReportDialog'
import log from '@/logger'
import api from '@/backend/api'

export default {
  name: 'ReturnList',
  components: {  BundleProgress, ConfirmReportDialog, PaperWeb},
  props: {
    label: { type: String, required: true },
    paperType: { type: Number, required: true },
    reportState: { type: Number, required: true },
    printing:{type:Boolean, required:false, default:false}
  },
  data() {
    return {
      rs: types,
      valid: true,
      errors:[],
      showConfirm:false,
      dialog:false,
      loading:false
    }
  }, 
  computed: {
    ...mapState({
      theBundles: state => state[APP_OPEN_BUNDLES],
      allDates: state => state[APP_DATES],
      allPapers: state => state[APP_PAPERS],
       lastBundleId: state => state[APP_LAST_SELECTED_BUNDLE_ID]
    }),
    openBundles() {
      return this.theBundles[this.paperType]
    },
    dates() {     
      return this.allDates[this.paperType]
    },
    papers(){
      return this.allPapers[this.paperType]
    },
    isReportStateRetur(){
      return this.reportState===1
    }

  },
  watch: {  
    reportState(val) {
      console.log('ReportState:', val)
      this.loadData(val)
    }    
  },
  created() {    
    this.loadData(this.reportState)
    log.debug(Object.keys(this.dates).length)
  },
  methods: {
    ...mapMutations({
      setPapers: SET_PAPERS,
      setOpenBundles: SET_OPEN_BUNDLES,
      resetState: REMOVE_LAST_SELECTED_BUNDLE_ID,
      setLastBundleId: SET_LAST_SELECTED_BUNDLE_ID
    }),
    showReport(day) {
      var model = {
        day: clone(day),
        bundles: clone(this.openBundles)
      }
      this.$refs['dayDialog'].open(model)
    },
    closeReportDialog() {
      this.loadData(this.reportState)
      this.resetState()
      this.$refs['dayDialog'].close()
    },
    showBundle(bundle) {
      var model = {
        bundle: bundle
      }
      model.bundle.open = undefined
      this.$refs['confirmDialog'].open(model)
    },
  
    closeBundleDialog() {
      this.loadData(this.reportState)
      this.$refs['confirmDialog'].close()
    },
    confirmed(){
      this.showConfirm = false
    },
    loadData(reportState) {
      this.loading = true
      var paperType = this.paperType
      const vm = this
      api.getPapers(paperType, reportState).then(resp => {        
        var papers = resp.data
        var tempId = 0      
        if(this.reportState === 1){
          papers.forEach(p => {
            p.returns.push({ isOpen: true, id: `${tempId}-${p.id}`, paperId: p.id, type: p.type, deliveredAmount:p.deliveredAmount })
          })
        }else{
          papers.forEach(p => {
            p.returns.forEach(r=>{
               this.$set(r, 'paperId',p.id)
               this.$set(r, 'type',p.type)
               this.$set(r, 'deliveredAmount',p.deliveredAmount)               
            })            
          })
        }

        log.debug(`Papers[${paperType}]:`, papers)
        this.setPapers({ papers: papers, paperType })
        this.loading = false
      }).catch(error =>{
         log.debug(error)
         this.loading = false
         if(error.response.status === 401){           
           vm.$router.push('/login')
         }
          
        })
      api.getOpenBundles(paperType).then(resp => {
        log.debug(`Bundles[${paperType}]:`, resp.data)
        this.setOpenBundles({ bundles: resp.data, paperType })
      })
    },
   
    reported(paper){
      if(this.reportState == 1){
        const index = this.papers.findIndex(p => p.id === paper.id)
        console.log(`${paper.id} found at ${index}`)
        if(index >= 0){
          this.papers.splice(index,1)
        }
      }
    },
    
    validate() {
      if(this.$refs.form === undefined){
        return true
      }
      return  this.$refs.form.validate()
    },
    save() {      
      if(this.validate()){      
        var promises = []
        this.papers.forEach(paper => {              
          paper.returns.forEach(ret => {
            let bundleId = ret.bundleId
            let amount = ret.amount
            if(paper.hasError !== undefined){
              this.$set(paper, 'hasError', false)
              this.$set(paper, 'error', undefined)
            }
            if (ret.isOpen && bundleId && amount >= 0) {
                promises.push(api.addPapers(bundleId, paper, amount))  
                //promises.push(api.addPapersTemporary(bundleId, paper, amount))
            }          
          })                       
        })
        
        Promise.all(promises.map(
            p => p.catch(errors => { 
              log.debug('SaveReturn Errors...', errors.response.data.error)
              this.hasError(errors.response.data)                
            })
          )).then(results => {
            
            results.forEach(resp => {
              if(resp !== undefined){
                log.debug('SaveReturn Success...', resp.data.paper)
                this.reported(resp.data.paper)
              }
            }) 

            if(!results.includes(undefined)){
              var paperType = this.paperType
              api.getOpenBundles(paperType).then(resp => {
                log.debug(`Bundles[${paperType}]:`, resp.data)
                this.setOpenBundles({ bundles: resp.data, paperType })
              })
              this.$refs['confirmDialog'].open()
            }
            
          })
          .catch(errors => {
            log.debug('SaveReturn Catch...', errors.response.data.error)            
          })
          // })
          // .then(results => {
          //   results.forEach(resp => {
          //     log.debug('SaveReturn Success...', resp)
          //     this.reported(resp.data)
          //   })
          // })
          // .catch(errors => {
          //   log.debug('SaveReturn Errors...', errors.response.data.error)
          //   error = true
          // })
          .finally(() => {          
          })
      }     
    }
  }
}
</script>

<style lang="scss">  
  .kvt-btn.v-btn--outlined {
    border: 2px solid;
  }
</style>